



import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import reportModule from '@/store/modules/common/report.module';
import { Table, TableHeader } from '@/store/models';
import VTable from '@/components/items/VTable.vue';

@Component({
  name: 'ReportChart',
  components: { VTable }
})
export default class ReportChart extends Vue {
  public sortData: any[] | [] = [...this.reportData];

  get reportData() {
    return reportModule.reportData.map(item => {
      return {
        coachName: `${item['coachFirstName']} ${item['coachLastName']}`,
        noOfCoachingSessionsCompleted: +item['no.OfCoachingSessionsCompleted'],
        noOfEmployeesCoached: +item['no.OfEmployeesCoached'],
        percentCompletionOfActionItems: +item['percentCompletionOfActionItems'],
        coachingSuccessIndex: +item['coachingSuccessIndex(CSI)Score']
      };
    });
  }

  get query() {
    return this.$route.query;
  }

  @Watch('query', { immediate: true, deep: false })
  public updateSort() {
    const sortQuery = this.$route.query.order_by;
    if (!sortQuery) return;
    this.sortData = [
      ..._.orderBy(
        this.reportData,
        [sortQuery.slice(1, sortQuery.length)],
        [sortQuery.slice(0, 1) === '-' ? 'asc' : 'desc']
      )
    ];
  }

  get tableData() {
    return {
      headers: [
        {
          name: 'Coach',
          width: 'width--20',
          order: true,
          query: 'coachName'
        } as TableHeader,
        {
          name: 'No. of Coaching</br>Sessions completed',
          width: 'width--20',
          order: true,
          query: 'noOfCoachingSessionsCompleted'
        } as TableHeader,
        {
          name: 'No. of Employees Coached',
          width: 'width--20',
          order: true,
          query: 'noOfEmployeesCoached'
        } as TableHeader,
        {
          name: 'Total % Completion of Action Items of All Employees Per Coach',
          width: 'width--20',
          order: true,
          query: 'percentCompletionOfActionItems',
          type: 'percent'
        } as TableHeader,
        {
          name: 'Coaching Success Index (CSI) Score',
          width: 'width--20',
          order: true,
          query: 'coachingSuccessIndex'
        } as TableHeader
      ],
      property: {
        edit: false,
        delete: false,
        index: false,
        func: () => {},
        overflow_y: true
      },
      values: { data: this.sortData }
    } as Table;
  }
}
